module.exports = __webpack_public_path__ + "static/media/patrol(3).b8b29e49.PNG";